export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8070.38c75725.jpg";